import { apiLoadSettings, apiSaveSettings } from "./baseApi"

export const apiSaveCategorySettings = (data, callback) => {
  apiSaveSettings(data, callback, 'category')
}

export const apiLoadCategorySettings = (callback) => {
  apiLoadSettings(callback, 'category')
}